import React from 'react';
import TaskManager from '../components/TaskManager';
import MaterialCostCalculator from '../components/MaterialCostCalculator';
import ProjectTimelineGenerator from '../components/ProjectTimelineGenerator';
import DocumentCenter from '../components/DocumentCenter';
import FeedbackSystem from '../components/FeedbackSystem';

const ToolsPage = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-4xl font-bold text-center mb-8">Herramientas Útiles</h1>
      <TaskManager />
      <MaterialCostCalculator />
      <ProjectTimelineGenerator />
      <DocumentCenter />
      <FeedbackSystem />
    </div>
  );
};

export default ToolsPage;
